var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 137,
    viewBox: "0 0 192 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.256 51.6188C148.866 22.1345 124.851 0 96 0C73.0938 0 53.1996 14.0157 43.2921 34.5265C19.4348 37.2612 0.887939 59.054 0.887939 85.4616C0.887939 113.749 22.2089 136.739 48.444 136.739H151.482C173.358 136.739 191.112 117.595 191.112 94.0077C191.112 71.4459 174.864 53.1571 154.256 51.6188ZM151.482 119.646H48.444C30.9275 119.646 16.74 104.349 16.74 85.4616C16.74 67.942 28.8667 53.328 44.9565 51.5333L53.4374 50.5933L57.4004 42.4744C64.9301 26.8349 79.6724 17.0923 96 17.0923C116.766 17.0923 134.679 32.9882 138.721 54.9518L141.099 67.771L153.226 68.7111C165.59 69.5657 175.26 80.7612 175.26 94.0077C175.26 108.109 164.56 119.646 151.482 119.646ZM64.296 76.9154H84.5073V102.554H107.493V76.9154H127.704L96 42.7308L64.296 76.9154Z",
    fill: "#D3DDEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudIcon);
export default __webpack_public_path__ + "static/media/UploadCloudIcon.f2394097.svg";
export { ForwardRef as ReactComponent };